import { Screen } from '@reference-data/screen.enum';
import React from 'react';
import { connect } from 'react-redux';
import { PageTitleComponent } from 'src/common-ui/page-title/page-title.component';
const OperationPopup = ({}) => {
    return (React.createElement("div", { className: "operation-popup-page", "data-testid": `${Screen.SETTINGS_OPERATION_POPUP}-page` },
        React.createElement(PageTitleComponent, { title: "popup_html_operation_popup", isBackButtonEnabled: true })));
};
const mapStateToProps = (state) => {
    return {};
};
const connector = connect(mapStateToProps, {});
export const OperationPopupComponent = connector(OperationPopup);
